import React, { useEffect, useRef } from 'react';
import { Instagram, Music2, Mail, Link2 } from 'lucide-react';
import '../styles/musician.css';
import { musicianData } from '../mock';

const MusicianBio = () => {
  const bioSectionRef = useRef(null);
  const contactSectionRef = useRef(null);

  // Map icon names to components
  const iconComponents = {
    Instagram,
    Music2,
    Mail
  };

  // Scroll animation observer
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    const bioSection = bioSectionRef.current;
    const contactSection = contactSectionRef.current;

    if (bioSection) observer.observe(bioSection);
    if (contactSection) observer.observe(contactSection);

    return () => {
      if (bioSection) observer.unobserve(bioSection);
      if (contactSection) observer.unobserve(contactSection);
    };
  }, []);

  return (
    <div className="musician-biography-page">
      {/* Hero Section */}
      <section className="musician-hero">
        <img 
          src={musicianData.heroImage} 
          alt={musicianData.name}
          className="musician-hero-bg"
        />
        <div className="musician-hero-overlay"></div>
        <div className="musician-hero-content">
          <img 
            src={musicianData.logoImage} 
            alt="Logo"
            className="musician-hero-logo-center"
          />
        </div>
      </section>

      {/* Music Streaming Section */}
      <section className="musician-music-section">
        <div className="musician-container">
          <h3 className="musician-music-title">
            <span className="musician-music-title-highlight">
              <span className="musician-exclamation">!</span>
              YENİ SINGLE YAYINDA
              <span className="musician-exclamation">!</span>
            </span>
            <br /><br />
            Deli Divane (Rock Cover)
            <br /><br />
            Dinlemek için Tıkla 👇🏻
          </h3>
          <div className="musician-music-links">
            <a
              href="https://linktr.ee/BuIsteBirSerserilikVar"
              target="_blank"
              rel="noopener noreferrer"
              className="musician-music-link-item musician-all-platforms-link"
              aria-label="Tüm Platformlar"
            >
              <span className="musician-music-text">Tüm Platformlar</span>
              <div className="musician-music-logo musician-link-icon">
                <Link2 size={40} strokeWidth={2.5} />
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Biography Section */}
      <section 
        ref={bioSectionRef}
        className="musician-bio-section musician-section scroll-fade-in"
      >
        <div className="musician-container">
          <h2 className="musician-section-title">Hikaye</h2>
          <div className="musician-bio-content">
            {musicianData.biography.map((paragraph, index) => (
              <p key={index} className="musician-body-text musician-bio-text">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section 
        ref={contactSectionRef}
        className="musician-contact-section scroll-fade-in"
      >
        <div className="musician-container">
          <div className="musician-contact-content">
            <h2 className="musician-contact-title">İletişim</h2>
            <a 
              href={`mailto:${musicianData.contact.email}`}
              className="musician-email"
            >
              {musicianData.contact.email}
            </a>
            
            <div className="musician-social-links">
              {musicianData.contact.social.map((social, index) => {
                const IconComponent = iconComponents[social.icon];
                return (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="musician-social-link"
                    aria-label={social.name}
                  >
                    {IconComponent && <IconComponent />}
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="musician-footer">
        <div className="musician-container">
          <p className="musician-footer-text">
            © {new Date().getFullYear()} {musicianData.name}. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default MusicianBio;
